export default __webpack_public_path__ + "static/media/mp.c2d801d4.svg";